import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sucking is the first step",
  "description": "You ever feel like you have no idea what you're doing? Everyone feels that way. Sometimes more, sometimes less.",
  "published": "2020-10-19T00:00:00.000Z",
  "hero": "./img/screenshot-1603122646037.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You ever feel like you have no idea what you're doing?`}</p>
    <p>{`Like, how the heck does your team rely on you when you barely understand a fraction of the codebase, google for answers all the time, spend hours chasing bugs that are typos, and constantly look up basic syntax like `}<inlineCode parentName="p">{`for ... of`}</inlineCode>{` vs. `}<inlineCode parentName="p">{`for ... in`}</inlineCode>{`??`}</p>
    <p>{`Everyone feels that way Friend. Sometimes more, sometimes less.`}</p>
    <p><img parentName="p" {...{
        "src": "/110b795d802c4cc47eb14bc9f5f3ff52/416dcgif3373ii.gif",
        "alt": null
      }}></img></p>
    <p>{`My sister is a personal trainer and group class instructor. She called me this weekend.`}</p>
    <p><em parentName="p">{`"Swiz, they're closing gyms again for corona. 2 weeks at least. This is ridiculous, I made more in 4 months last year than all of 2020 combined ☹️"`}</em></p>
    <p><em parentName="p">{`"Okay so what you gonna do about it?"`}</em></p>
    <p><em parentName="p">{`"I don't know everything sucks, I suck, this is stupid"`}</em></p>
    <p><em parentName="p">{`"Sure that's fine but what you gonna do about it?`}</em></p>
    <p><em parentName="p">{`"I was thinking of recording a Barre class and selling it online"`}</em></p>
    <p><em parentName="p">{`"Fantastic! Sounds like a plan 👏"`}</em></p>
    <p><em parentName="p">{`"Ugh but what if I'm not good enough? I don't know how to do this, I hate making videos, I don't have good gear, I can't edit, everything I do is shit, how would I even sell it, why would someone buy from me I'm just a nobody ... ugh"`}</em></p>
    <p><em parentName="p">{`"You're not a nobody to your clients. Email them, ask how you can help now that gyms are closed"`}</em></p>
    <p><em parentName="p">{`"Yeah but they're the gym's clients I can't contact them"`}</em></p>
    <p><em parentName="p">{`"Cmon I know you have your own clients. Don't any of them follow you on instagram? Send a message"`}</em></p>
    <p><em parentName="p">{`"Yeah but those came by accident. They showed up organically or they know somebody who worked with me in the past"`}</em></p>
    <p><em parentName="p">{`"Fantastic! Your clients refer other clients AND they stay"`}</em></p>
    <p><em parentName="p">{`"They're just staying because they don't know any better. I suck at this, why would they buy my course"`}</em></p>
    <p><em parentName="p">{`"At worst, you're good enough that clients are too lazy to find someone else. If you don't wanna make a course, offer private Zoom classes. That's a great way to experiment"`}</em></p>
    <p><em parentName="p">{`"Ugh but I hate Zoom it's hard to make a good class that way"`}</em></p>
    <p><em parentName="p">{`"Okay then make a course. You said Barre is a fantastic home workout and nobody offers recorded Barre classes yet. What's the problem?"`}</em></p>
    <p><em parentName="p">{`"I don't know I'm not good enough"`}</em></p>
    <p>{`Sound familiar?`}</p>
    <h2 {...{
      "id": "the-not-good-enough-trap"
    }}>{`The not good enough trap`}</h2>
    <p>{`You can't be good enough until you try. Start.`}</p>
    <p>{`Zen Pencils has a fantastic comic, `}<a parentName="p" {...{
        "href": "https://www.zenpencils.com/comic/90-ira-glass-advice-for-beginners/"
      }}>{`Ira Glass: Advice to Beginners`}</a>{`. It's about the delta between your taste and your skill.`}</p>
    <p>{`You get into a field because you have good taste. You appreciate a good app, you love a great website, you see good design, you understand good code.`}</p>
    <p>{`But you can't do that yet. You try and it's crap.`}</p>
    <p>{`And that's okay. That's how you start. Sucking at something is the first step to being good at something.`}</p>
    <p>{`You need a volume of work. Write code, build apps, create websites, draw. If you want to be good at something, `}<em parentName="p">{`you have to practice`}</em>{`.`}</p>
    <p><strong parentName="p">{`Sit your ass down and do the work.`}</strong></p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`5 months from now you won't see the difference between code that flowed and code you struggled with. Keep going`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1312047852512661504"
      }}>{`October 2, 2020`}</a></blockquote>
    <h2 {...{
      "id": "dont-be-afraid-to-start"
    }}>{`Don't be afraid to start`}</h2>
    <p>{`Wanna laugh your ass off?`}</p>
    <p>{`Here's my first ever ride on my brand new motorcycle. A 900cc beast of pure retro beautifulness. Watch with sound.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`First attempt went great! 😂😂😂 `}<a parentName="p" {...{
          "href": "https://t.co/ukIlBBq9S0"
        }}>{`pic.twitter.com/ukIlBBq9S0`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1052408869773668352"
      }}>{`October 17, 2018`}</a></blockquote>
    <p>{`Made it a whole 30cm before I fell over 😂`}</p>
    <p>{`What happens next is important 👉 picked the bike up, did a few laps in the garage. Ventured to the outdoors parking lot, soon the street.`}</p>
    <p>{`This summer I went on a `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=1-b2OLi0e78"
      }}>{`1000mi road trip to Death Valley and back`}</a>{`. 2 days of riding, 500mi each. Loved it to bits.`}</p>
    <p>{`Yeah I fell on my first try and yeah the bike's got many scratches since then. Some dumb, some sketchy, some kinda dangerous.`}</p>
    <p>{`But that's life. That's how you learn. How you get good.`}</p>
    <p>{`Accept that your first few tries are going to suck. Your first code will be terrible, your first feature will fail, your first app will die in obscurity, your first anything always sucks.`}</p>
    <p>{`And that's okay. It's part of the process.`}</p>
    <h2 {...{
      "id": "mistakes-matter"
    }}>{`Mistakes matter`}</h2>
    <p>{`Every good engineer has caused a production bug, deleted data by accident, screwed up an important demo, and lost their company thousands of dollars through one bug or another.`}</p>
    <p>{`And every good engineer got up afterwards, dusted themselves off, and fixed the issue. You gotta.`}</p>
    <p>{`You make the mess, you fix the mess.`}</p>
    <p>{`But if you never make a mess, you never get better. You're stuck in the junior dungeon killing level 1 rats. Grinding away with no progress.`}</p>
    <p>{`All because you're afraid of looking dumb or making mistakes?? 🤔`}</p>
    <p>{`The fastest way to train a junior engineer is to watch them make a mistake, know it's coming, and say nothing. `}<em parentName="p">{`They`}</em>{` have to experience it. `}<em parentName="p">{`You`}</em>{` have to let them.`}</p>
    <p>{`Experience is what we call it when things don't go the way you planned. You want experienced engineers on the team don't you?`}</p>
    <p><img parentName="p" {...{
        "src": "/7fbc74fdd431b6801fe2491c2532840b/giphygif08j699.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "dont-get-cozy"
    }}>{`Don't get cozy`}</h2>
    <p>{`Challenge yourself my friend.`}</p>
    <p>{`Want to avoid the `}<em parentName="p">{`"1 year of experience 10 times"`}</em>{` trap? Find or create a job that makes you feel like an impostor.`}</p>
    <p>{`Then figure it out on the go. I know you can ❤️`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: don't forget to `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/the-joy-of-being-a-beginner"
      }}>{`be a beginner every few months or years`}</a>{`, it's refreshing`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      